// "WHAT YOUR CREDIT DID", ABOVE "SAVE THIS AND FINISH" ON THE NO-CASE RESULT (WEB-DESIGN-1). The rows and why each word is
// what it is: `creditWorkRules.ts`. On every build: Tyler's approved heading and captions (draft B, approved 2026-10-05),
// each over the server's figures under the app's own labels. The one figure label still a draft, "sales found", shows
// only on a dev build with `?drafts=1`.

import type { EvaluateCaseResponse, SearchCompsResponse } from "@contract";
import { draftsOn } from "../../app/devPreview";
import { heldText } from "../../components/heldCopy";
import { Icon, type IconName } from "./parity4Parts";
import {
  CREDIT_WORK_CAPTIONS, CREDIT_WORK_DRAFTS, CREDIT_WORK_HEADING, creditWorkRows, labelText, shownFigures, type CreditWorkRowId,
  type R3Value,
} from "./creditWorkRules";

const ROW_ICONS: Readonly<Record<CreditWorkRowId, IconName>> = {
  sales: "search",
  record: "doc",
  history: "house",
  check: "seal",
  saved: "tick",
};

export function CreditWork({ v, comps, check }: { v: R3Value; comps: SearchCompsResponse; check: EvaluateCaseResponse }) {
  const drafts = draftsOn() && CREDIT_WORK_DRAFTS !== null;
  const rows = creditWorkRows(v, comps, check).map((row) => ({ row, figures: shownFigures(row, drafts) }));
  if (rows.length === 0) return null;
  return (
    <div className="credit-work" data-credit-work={drafts ? "drafts" : "approved"}>
      <h3 className="credit-work-title" data-held-copy={CREDIT_WORK_HEADING}>{heldText(CREDIT_WORK_HEADING)}</h3>
      <ul className="credit-work-rows">
        {rows.map(({ row, figures }) => (
          <li key={row.id} className="credit-work-row" data-work={row.id}>
            <span className="credit-work-icon" aria-hidden="true">
              <Icon name={ROW_ICONS[row.id]} size={18} />
            </span>
            <div className="credit-work-body">
              <p className="credit-work-caption" data-held-copy={CREDIT_WORK_CAPTIONS[row.id]}>
                {heldText(CREDIT_WORK_CAPTIONS[row.id])}
              </p>
              {figures.length > 0 && (
                <dl className="credit-work-figures">
                  {figures.map((figure) => (
                    <div key={`${figure.label.kind}:${figure.label.id}`} className="credit-work-figure">
                      <dt
                        data-app-copy={figure.label.kind === "draft" ? undefined : figure.label.id}
                        data-draft-copy={figure.label.kind === "draft" ? figure.label.id : undefined}
                      >
                        {labelText(figure.label)}
                      </dt>
                      <dd>{figure.value}</dd>
                    </div>
                  ))}
                </dl>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
